import React, { useState } from "react";

import { Button, H2, H3, H6, Image, Text } from "components";

function ShowhomeCard({
  show,
  logoSrc,
  logoFluid,
  logoAlt,
  directionsLink,
  address,
  contact,
  phone,
  website,
  home,
  email,
  category,
  sqft,
  price,
  fluid,
  src,
  alt,
  kitchen,
  masterBedroom,
  bathroom,
  livingRoom,
}) {
  const [activeImage, setActiveImage] = useState(fluid);

  return (
    <div
      css={`
        display: ${show ? "block" : "none"};
        &:not(:last-child) {
          margin-bottom: 5vw;
          padding-bottom: 5vw;
          border-bottom: 1px solid ${(props) => props.theme.colors.bg.reverse};
          ${(props) => props.theme.mediaQueries.small} {
            margin-bottom: 0;
            padding-bottom: 15vw;
            border-bottom: 0;
          }
        }
      `}
    >
      <div
        css={`
          display: -ms-grid;
          display: grid;
          -ms-grid-columns: 1fr ${(props) => props.theme.gutter} 1fr
            ${(props) => props.theme.gutter} 1fr
            ${(props) => props.theme.gutter} 1fr
            ${(props) => props.theme.gutter} 1fr
            ${(props) => props.theme.gutter} 1fr
            ${(props) => props.theme.gutter} 1fr
            ${(props) => props.theme.gutter} 1fr
            ${(props) => props.theme.gutter} 1fr
            ${(props) => props.theme.gutter} 1fr
            ${(props) => props.theme.gutter} 1fr
            ${(props) => props.theme.gutter} 1fr;
          grid-template-columns: repeat(12, 1fr);
          grid-gap: ${(props) => props.theme.gutter};
          align-items: center;

          ${(props) => props.theme.mediaQueries.medium} {
            -ms-grid-columns: 1fr ${(props) => props.theme.gutter} 1fr
              ${(props) => props.theme.gutter} 1fr
              ${(props) => props.theme.gutter} 1fr
              ${(props) => props.theme.gutter} 1fr
              ${(props) => props.theme.gutter} 1fr
              ${(props) => props.theme.gutter} 1fr
              ${(props) => props.theme.gutter} 1fr;
            grid-template-columns: repeat(8, 1fr);
          }

          ${(props) => props.theme.mediaQueries.small} {
            -ms-grid-columns: 1fr ${(props) => props.theme.gutter} 1fr
              ${(props) => props.theme.gutter} 1fr
              ${(props) => props.theme.gutter} 1fr;
            grid-template-columns: repeat(4, 1fr);
          }
        `}
      >
        <div
          css={`
            -ms-grid-column: 1;
            -ms-grid-column-span: 9;
            grid-column: 1 / 6;
            -ms-grid-row: 1;
            grid-row: 1;

            ${(props) => props.theme.mediaQueries.medium} {
              -ms-grid-column: 1;
              -ms-grid-column-span: 7;
              grid-column: 1 / 5;
            }
            ${(props) => props.theme.mediaQueries.small} {
              -ms-grid-column: 1;
              -ms-grid-column-span: 7;
              grid-column: 1 / 5;
              -ms-grid-row: 2;
              grid-row: 2;
            }
          `}
        >
          <div
            css={`
              width: 160px;
              height: 96px;
              ${(props) => props.theme.mediaQueries.small} {
                margin: 0 auto;
                img {
                  object-position: 50% 50% !important;
                }
              }
            `}
          >
            <a href={website} rel="noopener noreferrer" target="_blank">
              <Image
                src={logoSrc}
                fluid={logoFluid}
                alt={logoAlt}
                style={{ width: "100%", height: "100%" }}
                objectFit="contain"
                objectPosition="0% 50%"
              />
            </a>
          </div>
          <div
            css={`
              display: -ms-grid;
              display: grid;
              -ms-grid-columns: 1fr 5vw 1fr;
              grid-template-columns: 1fr 5vw 1fr;
              grid-row-gap: 5vw;
              margin-top: 48px;
              ${(props) => props.theme.mediaQueries.small} {
                margin-top: 24px;
              }
            `}
          >
            <div
              css={`
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                -ms-grid-column: 1;
                grid-column: 1;
                -ms-grid-row: 1;
                grid-row: 1;
                ${(props) => props.theme.mediaQueries.small} {
                  -ms-grid-column: 1;
                  -ms-grid-column-span: 3;
                  grid-column: 1 / 4;
                }
              `}
            >
              <Text
                children={`Showhome address`}
                mb="0.25em"
                fontSize={0.875}
                css={`
                  font-weight: 600;
                `}
              />
              <Text children={address} mb="1em" fontSize={0.875} />
              {directionsLink && (
                <a
                  href={directionsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button
                    children={`Directions`}
                    variant="default"
                    css={`
                      margin-top: auto;
                    `}
                  />
                </a>
              )}
              {/* {price && (
                <Text
                  children={price}
                  mb="2em"
                  fontSize={0.875}
                  fontWeight="bold"
                />
              )} */}
            </div>
            <div
              css={`
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                -ms-grid-column: 3;
                grid-column: 3;
                -ms-grid-row: 1;
                grid-row: 1;
                ${(props) => props.theme.mediaQueries.small} {
                  -ms-grid-column: 1;
                  -ms-grid-column-span: 3;
                  grid-column: 1 / 4;
                  -ms-grid-row: 2;
                  grid-row: 2;
                }
              `}
            >
              <Text
                children={`Builder contact`}
                mb="0.25em"
                fontSize={0.875}
                css={`
                  font-weight: 600;
                `}
              />

              <Text fontSize={0.875} mb="2em">
                {contact}
                <br />
                <a href={"tel:" + phone}>{phone}</a>
              </Text>
              {email && (
                <a href={"mailto:" + email}>
                  <Button
                    children={`Email builder`}
                    variant="peach"
                    css={`
                      margin-top: auto;
                    `}
                  />
                </a>
              )}
            </div>
          </div>
        </div>
        <div
          css={`
            -ms-grid-column: 11;
            -ms-grid-column-span: 13;
            grid-column: 6 / 13;
            -ms-grid-row: 1;
            grid-row: 1;
            ${(props) => props.theme.mediaQueries.medium} {
              -ms-grid-column: 9;
              -ms-grid-column-span: 7;
              grid-column: 5 / 9;
            }
            ${(props) => props.theme.mediaQueries.small} {
              -ms-grid-column: 1;
              -ms-grid-column-span: 7;
              grid-column: 1 / 5;
            }
          `}
        >
          <div
            css={`
              position: relative;
            `}
          >
            <div
              css={`
                ${(props) => props.theme.mediaQueries.small} {
                  margin: 0 -10vw;
                }
              `}
            >
              <Image
                fluid={activeImage}
                src={src}
                alt={alt}
                style={{ width: "100%" }}
              />
            </div>
            <div
              css={`
                position: absolute;
                right: 0;
                bottom: 32px;
                padding: 16px;
                background-color: ${(props) => props.theme.colors.bg.default};
                ${(props) => props.theme.mediaQueries.small} {
                  display: none;
                }
              `}
            >
              <H6 children={home} mb="0.5em" />
              <H6
                children={category}
                mb="0.25em"
                css={`
                  font-weight: 400;
                `}
              />
              {/* <H6
              children={sqft}
              css={`
                font-weight: 400;
              `}
            /> */}
            </div>
          </div>
          <div
            css={`
              display: none;
              ${(props) => props.theme.mediaQueries.small} {
                display: initial;
              }
            `}
          >
            <div
              css={`
                display: flex;
                margin-top: 2.5vw;
                > div {
                  flex: 1;
                }
              `}
            >
              <div>
                <H6 children={home} mb="0.5em" textAlign="center" />
              </div>
              <div>
                <H6
                  children={category}
                  mb="0.25em"
                  textAlign="center"
                  css={`
                    font-weight: 400;
                  `}
                />
                {/* <H6
                children={sqft}
                textAlign="center"
                css={`
                  font-weight: 400;
                `}
              /> */}
              </div>
            </div>
            {(kitchen || masterBedroom || bathroom || livingRoom) && (
              <>
                <H2
                  children={`Explore our homes`}
                  mt="1em"
                  mb="0.25em"
                  textAlign="center"
                />
                <div
                  css={`
                    display: none;
                    overflow: hidden;
                    ${(props) => props.theme.mediaQueries.small} {
                      display: initial;
                    }
                  `}
                >
                  <div
                    css={`
                      cursor: pointer;
                      text-align: center;
                      > * {
                        display: inline-block;
                        vertical-align: middle;
                      }
                    `}
                  >
                    <div>
                      <H6
                        children={`Exterior`}
                        onClick={() => {
                          setActiveImage(fluid);
                        }}
                      />
                    </div>
                    {kitchen && (
                      <>
                        <div
                          css={`
                            cursor: pointer;
                            width: 1px;
                            height: 16px;
                            margin: 8px 16px;
                            background-color: ${(props) =>
                              props.theme.colors.bg.reverse};
                          `}
                        />
                        <div>
                          <H6
                            children={`Kitchen`}
                            onClick={() => {
                              setActiveImage(kitchen);
                            }}
                          />
                        </div>
                      </>
                    )}
                    {masterBedroom && (
                      <>
                        <div
                          css={`
                            cursor: pointer;
                            width: 1px;
                            height: 16px;
                            margin: 8px 16px;
                            background-color: ${(props) =>
                              props.theme.colors.bg.reverse};
                          `}
                        />
                        <div>
                          <H6
                            children={`Bedroom`}
                            onClick={() => {
                              setActiveImage(masterBedroom);
                            }}
                          />
                        </div>
                      </>
                    )}
                    {livingRoom && (
                      <>
                        <div
                          css={`
                            cursor: pointer;
                            width: 1px;
                            height: 16px;
                            margin: 8px 16px;
                            background-color: ${(props) =>
                              props.theme.colors.bg.reverse};
                          `}
                        />
                        <div>
                          <H6
                            children={`Living room`}
                            onClick={() => {
                              setActiveImage(livingRoom);
                            }}
                          />
                        </div>
                      </>
                    )}
                    {bathroom && (
                      <>
                        <div
                          css={`
                            cursor: pointer;
                            width: 1px;
                            height: 16px;
                            margin: 8px 16px;
                            background-color: ${(props) =>
                              props.theme.colors.bg.reverse};
                          `}
                        />
                        <div>
                          <H6
                            children={`Bathroom`}
                            onClick={() => {
                              setActiveImage(bathroom);
                            }}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
          {(kitchen || masterBedroom || bathroom || livingRoom) && (
            <div
              css={`
                padding: 24px
                  calc((((100vw - (5vw * 2)) - (5vw * 11)) / 12) * 1);
                background-color: ${(props) => props.theme.colors.brand.peach};
                ${(props) => props.theme.mediaQueries.small} {
                  display: none;
                }
              `}
            >
              <H3
                children={`Explore our homes`}
                mb="0.5em"
                color="text.reverse"
              />
              <div
                css={`
                  overflow: hidden;
                `}
              >
                <div
                  css={`
                    cursor: pointer;
                    > * {
                      display: inline-block;
                      vertical-align: middle;
                    }
                  `}
                >
                  <>
                    <div>
                      <H6
                        children={`Exterior`}
                        color="text.reverse"
                        onClick={() => {
                          setActiveImage(fluid);
                        }}
                      />
                    </div>
                    <div
                      css={`
                        width: 1px;
                        height: 16px;
                        margin: 8px 16px;
                        background-color: ${(props) =>
                          props.theme.colors.bg.default};
                      `}
                    />
                  </>
                  {kitchen && (
                    <>
                      <div>
                        <H6
                          children={`Kitchen`}
                          color="text.reverse"
                          onClick={() => {
                            setActiveImage(kitchen);
                          }}
                        />
                      </div>
                      <div
                        css={`
                          width: 1px;
                          height: 16px;
                          margin: 8px 16px;
                          background-color: ${(props) =>
                            props.theme.colors.bg.default};
                        `}
                      />
                    </>
                  )}
                  {masterBedroom && (
                    <>
                      <div>
                        <H6
                          children={`Bedroom`}
                          color="text.reverse"
                          onClick={() => {
                            setActiveImage(masterBedroom);
                          }}
                        />
                      </div>
                      <div
                        css={`
                          width: 1px;
                          height: 16px;
                          margin: 8px 16px;
                          background-color: ${(props) =>
                            props.theme.colors.bg.default};
                        `}
                      />
                    </>
                  )}
                  {livingRoom && (
                    <>
                      <div>
                        <H6
                          children={`Living Room`}
                          color="text.reverse"
                          onClick={() => {
                            setActiveImage(livingRoom);
                          }}
                        />
                      </div>
                      <div
                        css={`
                          width: 1px;
                          height: 16px;
                          margin: 8px 16px;
                          background-color: ${(props) =>
                            props.theme.colors.bg.default};
                        `}
                      />
                    </>
                  )}
                  {bathroom && (
                    <>
                      <div>
                        <H6
                          children={`Bathroom`}
                          color="text.reverse"
                          onClick={() => {
                            setActiveImage(bathroom);
                          }}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ShowhomeCard;
